import OrderTracking from './OrderTracking';

export default OrderTracking;
